export const WORKFORCE_USER_TYPE = {
  ADMIN: "admin",
  CHECKER: "checker",
  CHECKER_TWO: "checker_two",
  APPROVER: "approver",
  BLWF_APPROVER: "blwf_approver",
  APPLICANT: "applicant",
  FACTORY_ADMIN: "factory_admin",
  DIRECTOR: "director",
  ASSOCIATION: "association",
  BGMEA_ASSOCIATION: "bgmea_association",
  BKMEA_ASSOCIATION: "bkmea_association",
  SECTION_ADMIN: "section_admin",
  SECTION_ADMIN_TWO: "section_admin_two",
  BLWF_SECTION_ADMIN: "blwf_section_admin",
  DOCTOR: "doctor",
  SEC1_DEPUTI_ASST_DIRECTOR: "sec1_deputi_asst_director ",
  SEC2_DEPUTI_ASST_DIRECTOR: "sec2_deputi_asst_director ",
  BLWF_CHECKER: "blwf_checker",
  BLWF_DEPUTI_ASST_DIRECTOR: "blwf_deputi_asst_director",
  BLWF_DIRECTOR: "blwf_director",
  EIS_COORDINATOR: "eis_coordinator",
  EIS_OFFICER: "eis_officer",
  EIS_ADVISOR: "eis_advisor",
  EIS_COMMITTEE: "eis_committee",
  BLWF_DOCTOR: "blwf_doctor",
  EIS_FINANCIAL_OFFICER: "eis_financial_officer",
  EIS_DOCTOR: "eis_doctor",
  BLWF_DOL_DIFE: "blwf_dol_dife",
  EIS_APPLICANT:"eis_applicant",
  BEPZA_ASSOCIATION: "bepza_association",
  LFMEAB_ASSOCIATION: "lfmeab_association",
  SECRETARY: "secretary",
  EIS_ASSOCIATION_COMMITTEE: "eis_association_committee",

};